<template>
  <div class="input-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="文字样式" name="2">
          <div class="setting-item clearFloat">
            <text-setting-complex-update
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :lineHeightType.sync="lineHeightType"
              :letterSpacingType.sync="letterSpacingType"
              :isThemeColor.sync="textIsThemeColor" 
              :colorArr.sync="color"
              :options="options"
            />
          </div>
          <div></div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="图标样式" name="3">
          <div class="content-item">
            <img-icon-upload
              class="mb16"
              :imgSrc.sync="iconSrc"
              :iconType.sync="iconType"
              :iconColor.sync="iconColor"
              :resInfo.sync="resInfo"
            />
            <div class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">位置</span>
              <el-radio-group v-model="iconPosition">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
              </el-radio-group>
            </div>
            <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
              <span class="mr16 fs14">颜色</span>
              <!-- <color-picker-theme-color
                class="flex1"
                :isThemeColor.sync="iconColorIsThemeColor"
                :color.sync="iconColor"
              >
              </color-picker-theme-color> -->
              <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
              </cx-color-picker>
            </div>
            <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="sliderMax" suffix="px" />
            <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="sliderMax" suffix="px" />
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '4')" title="边距" name="4">
          <cx-padding
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
            :sliderMax="sliderMax"
          />
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '5')" title="外观" name="5">
          <div class="content">
            <div class="content-item">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <cx-background :background.sync="background" imgType="10" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '6')" title="边框" name="6">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
          >
            <div class="content">
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24 clearFloat">
                <!--<div class="checkbox_colorPicker_container mb16">-->
                  <!--<span class="fs14">边框</span>-->
                <!--</div>-->
                <div class="checkbox_colorPicker_container mb16">
                  <cx-check-box :value.sync="showBorder">显示边框</cx-check-box>
                </div>
                <div v-show="showBorder" class="select-input-container verticallyTop">
                  <cx-border
                    :borderWidth.sync="borderWidth"
                    :borderStyle.sync="borderStyle"
                    :borderColor.sync="borderColor"
                    :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '7')" title="提示语样式" name="7">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
          >
            <div class="content">
              <text-setting-update
                style="margin-top: 4px;"
                :fontColor.sync="placeHolderFontColor"
                :fontFamily.sync="placeHolderFontFamily"
                :fontSize.sync="placeHolderFontSize"
                :fontWeight.sync="placeHolderFontWeight"
              />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import CxBackground from "modules/components/cxBackground"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "input-options-data",
  components: { CxBackground, controlWidthAndSizeAndZindex },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "8"],
      hoverOpt: [],
      this1: this,
      collapseActiveNames: [],
      activeType: 1,
      sliderMax: 360,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      isActive: true,
      borderChecked: true
    }
  },
  comments: {},
  created() {},

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      // this.getOptions();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    background: {
      get() {
        let background = this.getOptions.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.getOptions.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.bgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.getOptions.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    bgColor: {
      get() {
        return this.getOptions.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.getOptions.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.getOptions.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    showBorder:{
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showBorder", false)
      }
    },
    borderType: {
      get() {
        return this.getOptions.borderType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderType", false)
      }
    },
    borderWidth: {
      get() {
        return this.getOptions.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.getOptions.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.getOptions.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    opacity: {
      get() {
        return this.getOptions.hasOwnProperty("opacity") ? this.getOptions.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.getOptions.hasOwnProperty("boxShadowColor")
          ? this.getOptions.boxShadowColor
          : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.getOptions.hasOwnProperty("boxShadowH") ? this.getOptions.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.getOptions.hasOwnProperty("boxShadowV") ? this.getOptions.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.getOptions.hasOwnProperty("boxShadowBlur") ? this.getOptions.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.getOptions.hasOwnProperty("boxShadowSpread") ? this.getOptions.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    getOptions: function () {
      // return this.$getOptions()
      return this.options
    },

    // 文字样式
    fontFamily: {
      get() {
        return this.getOptions.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.getOptions.fontSize || 12
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontStyle: {
      get() {
        return this.getOptions.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    fontWeight: {
      get() {
        return this.getOptions.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    lineHeight: {
      get() {
        return this.getOptions.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    textDecoration: {
      get() {
        return this.getOptions.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    color: {
      get() {
        return this.getOptions.color || "#000"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.getOptions.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    writingMode: {
      get() {
        return this.getOptions.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    letterSpacing: {
      get() {
        return this.getOptions.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    textAlign: {
      get() {
        return this.getOptions.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          label: "竖排文字",
          _class: "icon-portal-text-down1",
          isActive: this.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.writingMode = val
      }
    },
    activeArrangement() {
      return this.getOptions.textAlign
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.getOptions.hasOwnProperty("textPaddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.getOptions, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        // return this.getOptions.padding || 0
        return this.checkAndSetPrimaryVal(this.getOptions, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        // return this.getOptions.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        // return this.getOptions.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        // return this.getOptions.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.getOptions, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    // border样式
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.getOptions.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.getOptions, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    // 图标
    iconPosition: {
      get() {
        return this.getOptions.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc: {
      get() {
        return this.getOptions.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.getOptions.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.getOptions.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.getOptions.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.getOptions.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.getOptions.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    placeHolderFontFamily: {
      get() {
        return this.getOptions.placeHolderFontFamily || ""
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontFamily", false)
      }
    },
    placeHolderFontSize: {
      get() {
        return this.getOptions.placeHolderFontSize || 14
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontSize", false)
      }
    },
    placeHolderFontWeight: {
      get() {
        return this.getOptions.placeHolderFontWeight || 400
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontWeight", false)
      }
    },
    placeHolderFontColor: {
      get() {
        return this.getOptions.placeHolderFontColor || ""
      },
      set(val) {
        this.$changeOptionsEV(val, "placeHolderFontColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}

::v-deep .shape-bg-color .el-radio__label {
  padding-left: 4px;
}

.color-picker-container.custom-shape-bg {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 80px);
}
</style>
